import React, { Component } from 'react';
import { Auth} from 'aws-amplify';
import { Form, Button} from "react-bootstrap"
import { Redirect } from 'react-router-dom';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import TextField from '../components/LoginSignupTextfield';
import './LoginSignup.css'
import CircularProgress from '@material-ui/core/CircularProgress';






class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            username: "",
            loggedIn: false,
            switchToSignUp: false, 
            switchtoForgotPassword: false,
            error: "",
            loading:false
        }
    }

    redirect = () => {

        this.props.history.push("/app/explore")

    }

    signIn = async () => {

        this.setState({
            loading: true
        })
        

        try {
            await Auth.signIn(this.state.username, this.state.password);
          
            this.setState({
                loggedIn: true
            })

        } catch (error) {
            //console.log('error signing in', error);
            this.setState({
                error: "Incorrect username or password",
                loading:false
            })
        }
    }

    handleInputChange = (event) => {

        var newState = {};
        newState[event.target.id] = event.target.value;
        this.setState(newState)
    }

    switchToSignUp = () => {
        this.setState({
            switchToSignUp: true
        })
    }

    switchtoForgotPassword = () => {
        this.setState({
            switchtoForgotPassword: true
        })

    }


    displayStep = () => {

        if (this.state.loggedIn) {
            return (<Redirect to="/app/explore"></Redirect>)
        }
        else if(this.state.switchtoForgotPassword){
            return (<ForgotPassword/>)
        }

        else if (this.state.switchToSignUp) {
            return (<SignUp />)
        }
        else {

            return(
            <>

                <h1>LOG IN</h1>
                <p>Welcome back!</p>
                <Form onChange={this.handleInputChange} style={{ display: "flex", flexDirection: 'column', margin: "20px" }}>
                    <TextField margin="normal" id="username" label="Username" />

                    <TextField margin="normal" id="password" label="Password" type="password" />
                    <p style={{ margin: "0px", fontSize: "12px", color: "#FF857E" }}>{this.state.error}</p>


                </Form>

               
                <button onClick={this.switchtoForgotPassword} style={{  marginTop: "8%", outline: "none", textDecoration: "underline", background: 'none', border: "none", color: "rgb(103, 212, 239)", fontSize: "16px" }}>I forgot my password</button>
                <p>Don't have an account? <span > <button onClick={this.switchToSignUp} style={{  outline: "none", textDecoration: "underline", background: 'none', border: "none", color: "rgb(103, 212, 239)", fontSize: "16px" }}> Create Account</button>  </span> </p>
               

                {this.state.loading ? 
                 <div>
                 <CircularProgress></CircularProgress>
                 </div>
                :
                <Button style={{width: "100%", height: "40px" }} onClick={this.signIn} variant="primary" type="submit">
                Log In
            </Button>

                }
               

                

            </>)

        }

    }

    render() {
        return (
            <div style={{ textAlign: "center", color: "white", display:"flex", alignContent:"center", flexDirection:"column" }}>

            {this.displayStep()}
            </div>

        )
    }
}
export default Login;